// src/components/ReportCard.jsx
import React, { useState, useEffect } from "react";
import LoadingLogo from "./LoadingLogo";

export default function ReportCard({ title, embedUrl, fullscreen = false }) {
  const [showIframe, setShowIframe] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowIframe(true), 10000); // 10 seconds
    return () => clearTimeout(timer);
  }, []);

  return (
        <div className={`w-full h-full relative ${fullscreen ? "p-0 m-0" : "p-4"}`}>
      {showIframe ? (
        <iframe
          src={embedUrl}
          title={title}
          className="w-full h-full border-0"
          allowFullScreen
        />
      ) : (
        <LoadingLogo />
      )}
    </div>
  );
}
